import { useEffect } from 'react';
import styled from 'styled-components';

import ReportSelectModal from '@/components/molecules/Modal/SelectModal/ReportSelectModal';
import HospitalSearchResult from '@/components/templates/mobile/home/HomeSearchTemplate/components/SearchResult/Hospital';
import { zIndex } from '@/constants/zIndex';
import DNSlideTab from '@/designComponents/organisms/DNSlideTab';
import { SearchDoctorViewModel } from '@/hooks/search/doctor/useSearchDoctorViewModel';
import { TotalSearchHospitalViewModel } from '@/hooks/search/hospital/useSearchHospitalViewModel';
import { SearchMagazineViewModel } from '@/hooks/search/magazine/useSearchMagazineViewModel';
import { SearchQuestionViewModel } from '@/hooks/search/qna/useSearchQuestionViewModel';
import { HomeSearchViewModel } from '@/hooks/search/useHomeSearchViewModel';
import useModal from '@/hooks/useModal';
import usePostReportModal from '@/hooks/usePostReportModal';
import useReportModal from '@/hooks/useReportModal';
import { IntegratedSearchTabType } from '@/types/search';

import DoctorSearchResult from './Doctor';
import IntegratedSearchResult from './Integrated';
import MagazineSearchResult from './Magazine';
import QnaSearchResult from './Qna';
interface Props {
  viewModel: HomeSearchViewModel;
  qnaViewModel: SearchQuestionViewModel;
  magazineViewModel: SearchMagazineViewModel;
  doctorViewModel: SearchDoctorViewModel;
  hospitalViewModel: TotalSearchHospitalViewModel;
  isMobileWeb: boolean;
}
export const DIRECT_SEARCH_KEYWORD_TYPE = {
  RECENT: 'recent',
} as const;
export type DIRECT_SEARCH_KEYWORD_TYPE = (typeof DIRECT_SEARCH_KEYWORD_TYPE)[keyof typeof DIRECT_SEARCH_KEYWORD_TYPE];

const SearchResult = ({
  viewModel,
  qnaViewModel,
  magazineViewModel,
  doctorViewModel,
  isMobileWeb,
  hospitalViewModel,
}: Props) => {
  const { showModal } = useModal();
  const { showReportModal, onCloseReportModal, reportItems } = useReportModal();
  const {
    showReportModal: showPostReportModal,
    onCloseReportModal: onClosePostReportModal,
    reportData: reportPostData,
    reportItems: reportPostItems,
  } = usePostReportModal();

  useEffect(() => {
    if (!viewModel.modal.isOpen) {
      return;
    }

    showModal({
      ...viewModel.modal.info,
    });
  }, [viewModel.modal]);

  return (
    <>
      <StickyWrapper isMobileWeb={isMobileWeb}>
        <DNSlideTab value={viewModel.selectedTabValue}>
          {viewModel.INTEGRATED_SEARCH_RESULT_TABS.map((tab) => (
            <DNSlideTab.Item
              key={tab.key}
              label={tab.label}
              isActive={tab.value === viewModel.selectedTabValue}
              onClick={() => viewModel.onClickTabItem(tab)}
            />
          ))}
        </DNSlideTab>
      </StickyWrapper>

      {viewModel.selectedTabValue === IntegratedSearchTabType.All && (
        <IntegratedSearchResult viewModel={viewModel} doctorViewModel={doctorViewModel} />
      )}

      {viewModel.selectedTabValue === IntegratedSearchTabType.Qna && <QnaSearchResult viewModel={qnaViewModel} />}

      {viewModel.selectedTabValue === IntegratedSearchTabType.Magazine && (
        <MagazineSearchResult viewModel={magazineViewModel} />
      )}

      {viewModel.selectedTabValue === IntegratedSearchTabType.Doctor && (
        <DoctorSearchResult viewModel={doctorViewModel} />
      )}

      {viewModel.selectedTabValue === IntegratedSearchTabType.Hospital && (
        <HospitalSearchResult
          hospitalViewModel={hospitalViewModel}
          address={viewModel.getHeaderAddress()}
          getCurrentLocation={viewModel.requestGeolocationPermission}
          geolocationPermissionLoading={viewModel.geolocationPermissionLoading}
        />
      )}

      {reportItems && (
        <ReportSelectModal isVisible={showReportModal} onClose={onCloseReportModal} selectList={reportItems} />
      )}
      {reportPostItems && (
        <ReportSelectModal
          isVisible={showPostReportModal}
          onClose={onClosePostReportModal}
          selectList={reportPostItems}
          title={reportPostData?.isMine ? '게시글 관리' : '신고하기'}
        />
      )}
    </>
  );
};

export default SearchResult;

const StickyWrapper = styled.div<{
  isMobileWeb?: boolean;
}>`
  z-index: ${zIndex.TabSticky};
  ${({ theme, isMobileWeb }) => `
    position: sticky;
    top: ${
      isMobileWeb
        ? theme.size.mobileWebHeader.height + theme.size.headerSearchBar.height
        : theme.size.headerSearchBar.height
    }px;
    background: ${theme.color.white};
  `};
`;
